import { useGetToolProjectsQuery } from 'app/services/tools';
import { Tool, ToolProject } from 'app/types/tool';
import { Column, ColumnTypes, DataTable } from 'components';
import { useTranslation } from 'react-i18next';

type HistoryTableProps = {
  tool?: Tool;
  // Pre-fetched project/site history (e.g. from the public tool overview endpoint) -
  // when provided, the authenticated per-tool query below is skipped entirely.
  data?: ToolProject[];
};

const HistoryTable = ({ tool, data: dataOverride }: HistoryTableProps) => {
  const { t } = useTranslation();

  const { data: fetchedData, isLoading, isFetching } = useGetToolProjectsQuery(tool?.Id ?? 0, { skip: !tool || !!dataOverride });
  const data = dataOverride ?? fetchedData;

  const columns: Column[] = [
    {
      key: 'CreatedAt',
      title: t('common.createdat'),
      type: ColumnTypes.DATE
    },
    {
      key: 'SiteAddress',
      title: t('entities.site.address'),
      type: ColumnTypes.TEXT
    },
    {
      key: 'ProjectName',
      title: t('entities.project.workplace'),
      type: ColumnTypes.LINK,
      link: (record) => `/sites/${record.SiteId}/projects/${record.ProjectId}`
    },
    {
      key: 'CreatedBy',
      title: t('common.createdby'),
      type: ColumnTypes.TEXT
    },
  ];

  return (
    <DataTable
      data={data || []}
      columns={columns}
      isLoading={isLoading || isFetching}
      pagination={true}
      tableKey="ToolProjects"
    />
  );
};


export default HistoryTable;
